import axios from '@/service/interceptor';
import settings from '@/utils/settings';
import _ from 'lodash';
import Config from '@/utils/Config';

export default {
    getWebContent: _.debounce(
        async () => {
            try {
                const [webContentDefault, webContent] = await Promise.all(
                    [{ channel: Config.webContentDefaultChannel }, null].map(
                        item =>
                            axios
                                .get(`${settings.HOST}/bittrade/v2/me`, {
                                    params: {
                                        cmd: 'webContentInfo',
                                        ...item
                                    }
                                })
                                .then(res => {
                                    try {
                                        const data = JSON.parse(res.data.data);
                                        return Object.keys(data).reduce(
                                            (acc, cur) => ({
                                                ...acc,
                                                [cur]:
                                                    typeof data[cur] ===
                                                    'string'
                                                        ? JSON.parse(data[cur])
                                                        : data[cur]
                                            }),
                                            {}
                                        );
                                    } catch (e) {
                                        return {};
                                    }
                                })
                    )
                );
                const resultWebContent = {
                    ...webContentDefault,
                    ...webContent,
                    config: _.merge(webContentDefault.config, webContent.config)
                };
                return resultWebContent;
            } catch (e) {
                return {};
            }
        },
        1000,
        { leading: true, trailing: true }
    )
};



// WEBPACK FOOTER //
// ./src/utils/webcontent.js